.radio-group__heading {
  display: inline-flex;
  padding-bottom: var(--spacing-sm);
}

.radio-group__items {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: calc(var(--spacing-xl) / 2) var(--spacing-xl);
  align-items: center;
}

@media (width <= 600px) {
  .radio-group {
    grid-template-columns: 1fr;
  }
}
